export const entityViewModes = {
  READ: 'read',
  EDIT: 'edit',
  CREATE: 'create',
}
export const ENTITY_ROOT_QUERY_KEY = 'entities'
